import angular from 'angular';
import {
  loaderService,
  ssDialogService,
  vmDataService,
} from 'app/services';
import {
  confirmDialog,
  alerts,
} from 'app/components/global';
import editMasterProductDialog from '../masterProducts/editMasterProductDialog';
import editMasterVendorDialog from './editMasterVendorDialog';
import MasterProductDirectiveController from '../masterProducts/master-product.directive.controller';
import MasterVendorDirectiveController from './master-vendor.directive.controller';
import MasterVendorsDirectiveController from './master-vendors.directive.controller';
import masterProductDirective from '../masterProducts/master-product.directive';
import masterVendorDirective from './master-vendor.directive';
import masterVendorsDirective from './master-vendors.directive';


const masterVendorsModule = angular.module('app.components.admin.vendorManagementAdmin.masterVendors', [
  alerts,
  confirmDialog,
  editMasterProductDialog,
  editMasterVendorDialog,
  loaderService,
  ssDialogService,
  vmDataService,
]);

masterVendorsModule
  .directive('vmaMasterVendors', masterVendorsDirective)
  .controller('VMAMasterVendorsDirectiveController', MasterVendorsDirectiveController)
  .directive('vmaMasterVendor', masterVendorDirective)
  .controller('VMAMasterVendorDirectiveController', MasterVendorDirectiveController)
  .directive('vmaMasterProduct', masterProductDirective)
  .controller('VMAMasterProductDirectiveController', MasterProductDirectiveController);

export default masterVendorsModule.name;

console.log('app.components.admin.vendorManagementAdmin.masterVendorsModule created');
